// src/components/GuideOverlay.js
import React, { useState } from 'react';
import { 
  Dialog,
  DialogContent,
  Typography,
  Button,
  Link as MuiLink,
  Box 
} from '@mui/material';
import DonationModal from './DonationModal';

const GuideOverlay = ({ open, onClose }) => {
  const [donationOpen, setDonationOpen] = useState(false);

  const handleOpenDonation = () => {
    setDonationOpen(true);
  };

  const handleCloseDonation = () => {
    setDonationOpen(false);
  };

  const handleCloseDialog = () => {
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
        PaperProps={{
          sx: {
            backdropFilter: 'blur(5px)',
            backgroundColor: '#fff',
            color: '#000',
            position: 'relative',
          },
        }}
      >
        <DialogContent
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            position: 'relative',
            pb: '120px',
          }}
        >
          <Typography variant="h5" gutterBottom>
            Benvenuto sulla nostra Web App per tracciare le tue spese!
          </Typography>

          <Typography variant="body1" paragraph>
            L'applicazione è attualmente totalmente gratuita e senza pubblicità, non rivenderemo i tuoi dati a terzi e utilizzeremo i dati solo per gestire l'applicazione.
          </Typography>

          <Typography variant="body1" paragraph>
            Questo status durerà fin quanto sarà sostenibile. Come mantenere questo status? Se l'app vi piace potete donare una cifra a vostra discrezione per supportarlo, più persone doneranno e più sarà possibile mantenere questa modalità e apportare aggiornamenti nel tempo.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Come funziona?</strong><br />
            La nostra è una web app, ossia non dovete scaricare nulla dagli store: vi basta usare il link del sito o creare una shortcut sul vostro smartphone per poterla usare. In basso a destra nella dashboard troverete un pulsante "Aggiungi", che vi permette di inserire le spese.
          </Typography>

          <Typography variant="body1" paragraph>
            Siete di fretta e non sapete categorizzare la spesa? Nessun problema, inserite l'importo e confermate; nella Dashboard vi resterà il promemoria della spesa da aggiornare quando avrete il tempo.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Cos'è il codice Famiglia?</strong><br />
            Il codice famiglia è un codice che potete dare a un membro della vostra famiglia in modo che entrambi possiate inserire le vostre spese nello stesso Pool. Se sapete già che questo sarà necessario vi conviene farlo subito, in quanto una volta che siete in una famiglia entrerete in un ambiente differente e abbandonerete quello privato. Potete tornare in quello privato lasciando la famiglia.
          </Typography>

          <Typography variant="body1" paragraph>
            Potete controllare la lista delle spese e impostare il vostro budget dal pulsante "Spese". In questa sezione vedrete le spese divise per anno, mese e categoria, con i dettagli delle singole spese, oltre a poter settare il budget per ogni mese e avere sempre sotto mano quanto potete ancora spendere.
          </Typography>

          <Typography variant="body1" paragraph>
            Le statistiche vi aiuteranno invece a visualizzare in maniera veloce ed immediata le macro aree dove spenderete di più.
          </Typography>

          <Typography variant="body1" paragraph>
            Potete inserire una spesa con una data retroattiva: questo è utile quando avete passato il mese e dovete inserire la spesa nel mese precedente.
          </Typography>

          <Typography variant="body1" paragraph>
            <strong>Spese ricorrenti:</strong> <em>[Attenzione]</em> attualmente le spese ricorrenti sono solo un promemoria che apparirà nella Dashboard, in futuro verranno implementate per auto-registrarsi sulle vostre spese ma essendo una feature che richiede un certo impegno economico ulteriore, dobbiamo prima consolidare le donazioni: è in programma per essere sviluppato appena possibile.
          </Typography>

          <Typography variant="body1" paragraph>
            Potete cambiare il vostro tema in tema oscuro. Il design dell'app è pensato con uno stile E-ink e quindi performa meglio col bianco, ma se usato spesso potrebbe stancare i vostri occhi. Abbiamo pensato di dare questa possibilità per chi è più sensibile.
          </Typography>

          <Typography variant="body1" paragraph>
            Potete inviare i vostri feedback o suggerimenti o segnalare bug a{' '}
            <MuiLink
              href="mailto:info@quantospendo.com"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#000', textDecoration: 'underline' }}
            >
              info@quantospendo.com
            </MuiLink>.
          </Typography>

          <Typography variant="body1" paragraph>
            Parlatene ai vostri amici o parenti che pensiate abbiano necessità di tenere sotto controllo le proprie spese.
          </Typography>

          <Typography variant="body1" paragraph>
            L'applicazione è in fase di beta test, possono insorgere errori o problemi.
          </Typography>

          <Button
            variant="contained"
            sx={{ mt: 2, backgroundColor: '#000', color: '#fff' }}
            onClick={handleCloseDialog}
          >
            Non mostrare più
          </Button>
          <Button
            variant="contained"
            sx={{ mt: 2, ml: 2, backgroundColor: '#72a4f2', color: '#000' }}
            onClick={handleOpenDonation}
          >
            Dona
          </Button>
        </DialogContent>
      </Dialog>
      <DonationModal open={donationOpen} onClose={handleCloseDonation} />
    </>
  );
};

export default GuideOverlay;
